/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, Component } from "react";
import { MenuOutlined } from "@ant-design/icons";
import SideNav from "../../../sidenav";
import Noti from "../../../notification";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { changeLang } from "../../../../actions/langAction";
import { setOperation } from "../../../../actions/operationdataAction";
import { Link } from "react-router-dom";
import ChangePath from "../../../../services/ServiceApi";
import Api from "../../../../services/ServiceApi";
class LayoutOperation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      active: false,
      noti: false,
      hasNoti: false,
      username: Cookies.get("user"),
      type: [
        {
          value: 1,
          text: "Digital",
          operatorid: 1,
        },
      ],
      setUrl: "",
      operator: [],
      master_language: [],
      logopath: Cookies.get("logopath"),
      currentOperatorid: 3,
      projectData: [],
      filterProjectdata: [],
    };
  }

  async setOperationData() {
    const operationData = JSON.parse(Cookies.get("operation"));
    let typeValue = [];
    for (const i in operationData.operation_data) {
      let valueData = {
        value: operationData.operation_data[i].operator_id,
        text: operationData.operation_data[i].operator_name,
      };
      typeValue.push(valueData);
    }
    let ProjectData = [];
    for (const i in operationData.project_data) {
      let valueProject = {
        value: operationData.project_data[i].operator_id,
        text: operationData.project_data[i].project_name,
      };
      ProjectData.push(valueProject);
    }
    await this.setState({
      type: typeValue,
      projectData: ProjectData,
    });

    /* filter on first load */
    const project = this.state.projectData;
    const filterProjectdata = project.filter((data) => {
      // eslint-disable-next-line eqeqeq
      return data.value == this.state.currentOperatorid;
    });
    this.setState({
      filterProjectdata: filterProjectdata,
    });
  }
  async componentDidMount() {
    const data_language = await Api.post("master_language_detail_get", {
      company_id: parseInt(Cookies.get("companyid")),
      page_id: 1,
    });
    let promiseData = new Promise((resolve, reject) => {
      const data = Api.post("getNotiEmpSendData", {
        emp_id: Cookies.get("userId"),
        company_id: Cookies.get("companyid"),
        // emp_id:74,
        // company_id: 1,
      });
      resolve(data);
    });
    promiseData.then((res) => {
      if (res.data.data.length === 0) {
        this.setState({ hasNoti: false });
      } else {
        this.setState({ hasNoti: true });
      }
    });
    if (
      Cookies.get("locale") !== undefined
      // &&
      // Cookies.get("locale") !== Cookies.get("locale")
    ) {
      this.props.changeLang(Cookies.get("locale"));
    }

    if (
      localStorage.getItem("projectData") === null ||
      localStorage.getItem("projectData") === undefined
    ) {
      this.logoutClicked();
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        return data.operator_id === Cookies.get("operator_id");
      });
      this.setState({
        operator: JSON.parse(localStorage.getItem("operator")),
        projectData: filterProjectdata,
        master_language: data_language.data.data.masteR_LANGUAGE,
      });
    }
  }
  // setFilter(value) {

  //   const project = this.state.projectData;
  //   const filterProjectdata = project.filter((data) => {
  //     // eslint-disable-next-line eqeqeq
  //     return data.value == value;
  //   });
  //   console.log(filterProjectdata);
  //   this.setState({
  //     filterProjectdata: filterProjectdata,
  //   });
  // }
  CookiesChecker(currentlocation) {
    var PATTERN = "publicwebview";
    const checkUrl = window.location.href.indexOf(PATTERN);

    if (checkUrl === -1) {
      const moduleToken = Cookies.get("OperationToken");
      let identifier = {};
      // console.log(this);
      if (moduleToken) {
        try {
          identifier = ChangePath.post("tokenchecker", {
            TokenUser: moduleToken,
          });
        } catch (error) {
          identifier = error;
        }
        identifier.then((value) => {
          if (value.data.result.value === "P") {
            return null;
          } else {
            return this.logoutClicked();
          }
        });
      } else {
        return this.logoutClicked();
      }
    } else {
      var searchParams = new URLSearchParams(window.location.search);
      Cookies.set("companyid", searchParams.get("company"));
    }
  }
  setLang(locale) {
    Cookies.set("locale", locale.toLowerCase());
    this.props.changeLang(locale.toLowerCase());
  }
  setOperator = (operator_id) => {
    Cookies.set("operator_id", operator_id);

    const filterProjectdata = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id === operator_id;
    });

    Cookies.set("project_id", filterProjectdata[0].project_id);
    this.setState({
      projectData: filterProjectdata,
    });
    window.location.reload();
  };
  logoutClicked() {
    window.location.assign(Api.absoluteUrl("/login"));
    Cookies.remove("OperationToken");
    // window.location.reload(false);
  }
  setProjectData = (project_id) => {
    Cookies.set("project_id", project_id);
    console.log(this.state.projectData);
    window.location.reload();
  };

  render() {
    const { children, headername } = this.props;
    const { active, noti } = this.state;
    return (
      <Fragment>
        <nav className="navbar navbar-expand-lg navbar-light position-fixed">
          {this.CookiesChecker(window.location.pathname)}
          <Link className="navbar-brand" to="/">
            <img
              src={ChangePath.absoluteUrl("/logo/maxi_operation.png")}
              width="180"
              alt=""
            />
          </Link>
          <ul className="navbar-nav">
            <li className="nav-item">
              <button
                className={
                  active === true
                    ? "nav-link toggle-sidenav active"
                    : "nav-link toggle-sidenav"
                }
                onClick={() => this.setState({ active: !active })}
              >
                <MenuOutlined />
              </button>
            </li>
          </ul>
          <Link className="navbar-brand" to="/">
            <img
              src={ChangePath.absoluteUrl(this.state.logopath)}
              width="77"
              // height="36"
              alt=""
              // style={{ width: "54px", height: "21px" }}
            />
          </Link>
          <div className="container-fluid d-flex justify-content-center fs-16 font-mont-b c-blue text-uppercase">
            {headername}
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <a
                  className="nav-link position-relative"
                  onClick={() => this.setState({ noti: !noti })}
                >
                  {this.state.hasNoti ? (
                    <div className="alert-noti position-absolute"></div>
                  ) : (
                    ""
                  )}
                  <img
                    src={ChangePath.absoluteUrl("/icon/notifications.svg")}
                    width="30"
                    alt=""
                  />
                </a>
              </li>
              <li className="nav-item">
                <select
                  style={{
                    height: "30px",
                    fontSize: "16px",
                    width: "80px",
                    marginTop: "10px",
                    paddingLeft: "5px",
                    background: "#F9FAFE",
                    border: "0px",
                  }}
                  className="dropdrowtype font-thai-r"
                  onChange={(e) => this.setOperator(e.target.value)}
                  value={Cookies.get("operator_id")}
                >
                  {this.state.operator.map((item, index) => (
                    <option
                      value={item.operator_id}
                      key={`layoutoption_${index}`}
                    >
                      {item.operator_name}
                    </option>
                  ))}
                </select>
              </li>
              <li className="nav-item ml-3">
                <select
                  style={{
                    height: "30px",
                    fontSize: "16px",
                    width: "120px",
                    marginTop: "10px",
                    paddingLeft: "5px",
                    background: "#F9FAFE",
                    border: "0px",
                  }}
                  className="dropdrowtype font-thai-r"
                  onChange={(e) => this.setProjectData(e.target.value)}
                  value={Cookies.get("project_id")}
                >
                  {this.state.projectData.map((item, index) => (
                    <option value={item.project_id} key={`layout_b_${index}`}>
                      {item.project_name}
                    </option>
                  ))}
                </select>
              </li>
              <li className="nav-item ml-3">
                <select
                  style={{
                    height: "30px",
                    fontSize: "16px",
                    width: "80px",
                    marginTop: "10px",
                    paddingLeft: "5px",
                    background: "#F9FAFE",
                    border: "0px",
                  }}
                  className="dropdrowtype font-thai-r"
                  onChange={(e) => this.setLang(e.target.value)}
                  value={
                    Cookies.get("locale") === undefined
                      ? "EN"
                      : Cookies.get("locale").toUpperCase()
                  }
                  // defaultValue={}
                >
                  {this.state.master_language.map((item, index) => (
                    <option value={item.name_short} key={`layout_c_${index}`}>
                      {item.name_long}
                    </option>
                  ))}
                </select>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="h-100 d-flex align-items-center nav-link dropdown-toggle"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span
                    className="font-mont-m fs-14"
                    style={{ marginTop: "5px", fontSize: "14px" }}
                  >
                    {Cookies.get("username")}
                  </span>
                </a>
                <div
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <a className="dropdown-item" onClick={this.logoutClicked}>
                    Logout
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>

        {children}
        {noti ? <Noti /> : null}
        {active ? <SideNav active={this.props.active} /> : null}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  operation: state.operationReducer,
});

const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setOperation: (data) => dispatch(setOperation(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(LayoutOperation);
